export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Dashboard',
      //   route: '/Dashboard',
      //   icon: 'cil-speedometer',
      //   _attrs: { class: 'c-active' },
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Overview',
        to: '/Overview',
        icon: 'cil-speedometer',
        _attrs: { class: 'c-active c-sidebar-nav-item' },
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'E-Pay Transaction',
      //   to: '/EPayTransaction',
      //   icon: 'cil-wallet',
      //   color: 'success',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Duplicate Transaction',
      //   to: '/DuplicateTransaction',
      //   icon: 'cil-money',
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Learning Setting',
        route: '/TuitionSubject',
        icon: 'cil-cog',
        items: [
          {
            name: 'Subject',
            icon: 'cil-book',
            to: '/TuitionSubject'
          },
          {
            name: 'Package',
            icon: 'cil-clone',
            to: '/TuitionPackage'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Learning People',
        route: '/TuitionStudent',
        icon: 'cil-user',
        items: [
          {
            name: 'Student',
            icon: 'cil-user',
            to: '/TuitionStudent'
          },
          {
            name: 'Teacher',
            icon: 'cil-user-female',
            to: '/TuitionTeacher'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Attendance',
        route: '/TuitionAttendanceStudent',
        icon: 'cil-contact',
        items: [
          {
            name: 'Student Attendance',
            icon: 'cil-calendar-check',
            to: '/TuitionAttendanceStudent'
          },
          {
            name: 'Teacher Attendance',
            icon: 'cil-calendar-check',
            to: '/TuitionAttendanceTeacher'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Payment',
        route: '/TuitionPaymentStudent',
        icon: 'cil-dollar',
        items: [
          {
            name: 'Student Payment',
            icon: 'cil-cash',
            to: '/TuitionPaymentStudent'
          },
          {
            name: 'Teacher Payment',
            icon: 'cil-cash',
            to: '/TuitionPaymentTeacher'
          },
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Schedule',
        to: 'TuitionSchedule',
        icon: 'cil-calendar',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Broadcast',
        to: 'TuitionBroadcast',
        icon: 'cil-bell',
      },

      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Notification',
      //   to: 'Notification',
      //   icon: 'cil-bell',
      // },
      
      // {
      //   _name: 'CSidebarNavTitle',
      //   _children: ['ACCOUNT PAGES']
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Profile',
      //   to: 'Profile',
      //   icon: 'cil-user',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Sign Out',
      //   to: '',
      //   icon: 'cil-lock-locked',
      //   _attrs: { onclick: 'SignOut()',
      //   methods: {
      //     SignOut: function () {
      //       return this.$API
      //         .get(this.$SignOut, {
      //           withCredentials: true,
      //         })
      //         .then((response) => {
      //           if (response.status == 200) {
      //             this.$router.push("/Login");
      //           }
      //         });
      //     }
      //   }
      // }
      //},
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Sign Up',
      //   to: '',
      //   icon: 'cil-user-plus',
      //   _attrs: { class: 'disabledclass' },
      // },
     
    
     
     
    ],
   
  }
]




 